import styled, { css } from 'styled-components';
import { ButtonProps } from './Button';

interface ContainerProps {
	$variant: ButtonProps['variant'];
	$fitContent?: boolean;
	$active?: boolean;
}

export const Container = styled.button<ContainerProps>`
	padding: 0;
	border: none;
	background: none;
	cursor: pointer;
	position: relative;
	overflow: hidden;
	user-select: none;
	z-index: 1;

	&:disabled {
		pointer-events: none;
		opacity: 0.5;
	}

	${({ $variant, $fitContent, theme }) =>
		['contained', 'large', 'largeRed'].includes($variant) &&
		css`
			width: ${$fitContent ? 'fit-content' : '100%'};
			max-width: 300px;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 8px;
			background-color: ${$variant !== 'largeRed'
				? theme.colors.primary.medium
				: theme.colors.neutral.red};
			color: ${theme.colors.neutral.white};
			padding: ${$variant === 'contained' ? '8px 16px' : '16px'};

			&:before {
				content: '';
				background-color: ${theme.colors.neutral.black};
				width: 0;
				height: 0;
				position: absolute;
				left: 50%;
				top: 50%;
				border-radius: 50%;
				transition: 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
				z-index: -1;
			}

			&:hover {
				&:before {
					width: 300px;
					height: 300px;
					left: calc(50% - 150px);
					top: calc(50% - 150px);
				}
			}
		`}

	${({ $variant }) =>
		$variant === 'icon' &&
		css`
			width: 40px;
			height: 40px;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 50%;
			background-color: ${({ theme }) => theme.colors.neutral.black};
			transition: all 0.3s ease-out 0s;

			&:hover {
				background-color: ${({ theme }) => theme.colors.primary.medium};
			}
		`}

    ${({ $variant, $active, theme }) =>
		$variant === 'pagination' &&
		css`
			width: 40px;
			height: 40px;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 12px;
			background-color: ${$active ? theme.colors.primary.medium : theme.colors.neutral.black};
			transition: all 0.3s ease-out 0s;

			&:hover {
				background-color: ${theme.colors.primary.medium};
			}
		`}
`;

export const Label = styled.span`
	display: flex;
	align-items: center;
	gap: 4px;
	color: ${({ theme }) => theme.colors.neutral.white};
	font-size: 16px;
	font-weight: 600;
`;

export const Icon = styled.div`
	color: ${({ theme }) => theme.colors.neutral.white};
	width: 20px;
	height: 20px;
	font-size: 20px;
`;

export const Page = styled.div`
	color: ${({ theme }) => theme.colors.neutral.white};
	font-size: 16px;
	line-height: 0;
`;

export const Text = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	color: ${({ theme }) => theme.colors.primary.medium};
	font-size: 16px;
	font-weight: 600;
	transition: all 0.1s ease-out 0s;

	&:hover {
		color: ${({ theme }) => theme.colors.primary.light};
	}
`;
